export const SESSION_RESOURCE_TYPE = {
  LESSON: 'lesson',
  SESSION: 'session',
  GUIDE: 'guide',
};
